import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/es5/util/colors'
import VueI18n from 'vue-i18n';
import messages from '../i18n/messages';

Vue.use(Vuetify);
Vue.use(VueI18n);

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'he',
  messages,
})

export default new Vuetify({
  rtl: true,
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: colors.green.darken3,
        secondary: colors.orange.darken2
      }
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
});
